import { useMemo } from 'react'

import { SHOW_USER_EMAIL_FOR } from '@src/constants'
import useGetAccount from './useGetAccount'

// Opt-in: empty/unset env var means OFF for everyone. Customers with large
// teams and many duplicate display names (e.g. UniUni) get added to the list
// to disambiguate users in the picker dropdown by email.
export const useShowUserEmail = () => {
  const account = useGetAccount()

  return useMemo(() => {
    const teams =
      SHOW_USER_EMAIL_FOR?.split(',')
        ?.map((id: string) => id?.trim())
        .filter(Boolean) || []

    if (!teams.length || !account?.team) {
      return false
    }
    return teams.includes(account.team.id?.toString())
  }, [account])
}

export default useShowUserEmail
